@use 'src/global/variables' as var;

c-form-datepicker {
    input[type=date] {
      padding: 10px !important;
      margin:10px 0 !important;
      margin-left: var.$margin !important;
      width: 85% !important;
      border-radius: 10px !important;
    }

    input[type=date]::-webkit-calendar-picker-indicator {
      padding-left: 10px;
      border-left: 2px solid black;
    }

    label,
    input[type=date] {
      margin-left: var.$margin !important;
    }
}